import {Role} from "@app/user-management/roles/domain/role";
import {Language} from "@app/core/domain/Language";
import {Storage} from "@app/customer-management/organisation-units/domain/storage";
import { StorageType } from "./storage-type";
import {MailSettings} from "@app/customer-management/organisation-units/domain/mailsettings";

export class OrganisationUnit {

    constructor(id?: number) {
        this.id = id;
    }

    id: number;
    name: string;
    guid: string;
    uid: string;
    partnerString: string;
    registrationNumber: string;
    name2: string;
    email: string;
    countryCode: string;
    allowLogin: boolean;
    maintenanceModeActive: boolean;
    imageFileId: string;
    type: "main" | "parent"
    parent: any;
    parentId: number;
    defaultRoles: Role[];
    availableRoles: Role[];
    languages: Language[] = [];
    currencyIso: string;
    availableExternalSystems: any[] = [];
    primaryColor: string;
    secondaryColor: string;
    storage: Storage = new Storage(StorageType.DIG, null);
    addresses: any[] = [];
    bankAccounts: any[] = [];
    design: any;
    designVersion: any;
    forceTwoFactor: boolean = false;
    mailSettings: MailSettings;
    creationDate: Date;
}
